import {isMobile, isTablet} from "../helpers";
import {gsap} from "gsap";

export function initThreeIphonesRow() {
    if (!isMobile() && !isTablet()) {
        const iphones = gsap.utils.toArray('.three-iphones-block .iphone-plug');
        const iphonesLength = iphones.length;
        const percent = 100 / iphonesLength;

        iphones.forEach((item, index) => {
            const realIndex = +$(item).attr('data-item') || 0;
            let x = -(index + 1) * 110;
            let delay = index / percent;
            let mobileX = -100;
            let mobileXto = 30;

            gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    scroller: '.scroller',
                    start: `top-=110% bottom`,
                    end: `bottom-=130% top`,
                    scrub: isMobile() ? true : 0.8,
                },
            }).from($(item), {
                ease: "none",
                x: `${x}%`,
                willChange: 'transform',
            })
        })
    }
}
